<div class="step-title">Organization Info</div>
<div class="step-description">Personalize your organization account</div>

<div class="signup" [formGroup]="form">
    <div class="row field-container">
        <div class="col-8 col-md-5" [formGroup]="coverImage">
            <div class="header">Cover Image</div>
            <div class="position-relative mb-4 w-100">
                <div
                    *ngIf="coverImage.controls.dataUrl.value === '/images/blank_2x1.png'"
                    style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                    class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                >
                    <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="+" formControlName="file"></app-input-file>
                </div>
                <div
                    *ngIf="coverImage.controls.dataUrl.value !== '/images/blank_2x1.png'"
                    style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                    class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                >
                    <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetCoverImage()"></app-icon-delete>
                </div>
                <img style="border-radius: 5px" class="w-100" [src]="coverImage.controls.dataUrl.value">
            </div>
        </div>
        <div class="col-4 col-md-2" [formGroup]="logoImage">
            <div class="header">Logo</div>
            <div class="position-relative mb-4 w-100">
                <div
                    *ngIf="logoImage.controls.dataUrl.value === '/images/grey_1x1.png'"
                    style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                    class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                >
                    <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="+" formControlName="file"></app-input-file>
                </div>
                <div
                    *ngIf="logoImage.controls.dataUrl.value !== '/images/grey_1x1.png'"
                    style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                    class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                >
                    <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetLogoImage()"></app-icon-delete>
                </div>
                <img style="border-radius: 5px" class="w-100" [src]="logoImage.controls.dataUrl.value">
            </div>
        </div>
    </div>

    <div class="row field-container">
        <div class="col-12">
            <mdb-form-control class="form-fill"  >
                <app-mdbp-input mdbInput formControlName="handle" maxLength="12"  label='Unique Handle'></app-mdbp-input>
                <span class="form-fill-error"  *ngIf="form.controls.handle.touched">{{getHandleErrorMessage()}}</span>
            </mdb-form-control>
            <div class="mat-form-field-description mb-3 pr-5">
                <div class="opacity-50" [ngStyle]="form.controls.handle.touched && {'margin-top': '48px'} || null">PayBee uses this handle to create a unique URL for campaigns that also appear on card statements for donors. Please choose so that it is recognizable to the organization.</div>
            </div>
        </div>
    </div>

    <div class="row field-container">
        <ng-container *ngIf="categories$ | async as categories">
            <div class="col-12 col-md-6 mb-3 mb-md-0">
                <mdb-form-control class="form-fill">
                    <mdb-select formControlName="topCategoryId" class="mdb-select">
                      <mdb-option *ngFor="let category of categories" [value]="category.categoryId">{{
                        category.name
                      }}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label form-label--paybee">Select Organization Type</label>
                    <span class="form-fill-error" *ngIf="form.controls.topCategoryId.touched && form.controls.topCategoryId.invalid">Please provide Organization Type</span>
                </mdb-form-control>
            </div>
        </ng-container>
        <ng-container *ngIf="form.get('topCategoryId') && subcategories$ | async as subcategories">
            <div class="col-12 col-md-6" *ngIf="subcategories.length > 0">
                <mdb-form-control class="form-fill">
                    <mdb-select formControlName="secondCategoryId" class="mdb-select">
                      <mdb-option *ngFor="let subcategory of subcategories" [value]="subcategory.id">{{
                        subcategory.name
                      }}</mdb-option>
                    </mdb-select>
                    <label mdbLabel class="form-label form-label--paybee">Select Organization Subtype</label>
                    <span class="form-fill-error" *ngIf="form.controls.secondCategoryId.touched && form.controls.secondCategoryId.invalid">Please provide Organization Type</span>
                </mdb-form-control>
            </div>
        </ng-container>
    </div>

    <div class="row field-container">
        <div class="col-12">
            <mdb-form-control class="form-fill textarea-control signup"  >
                <app-mdb-textarea mdbInput formControlName="purpose"  maxLength="256" label="Short Mission Statement"></app-mdb-textarea>
            </mdb-form-control>
        </div>
    </div>

    <div class="row field-container">
        <div class="col-12">
        <div class="position-relative mb-4">
            <label class="form-check-label form-check-label--paybee mb-1">Description</label>
            <mdb-form-control class="mb-4">
                <app-quill-custom mdbInput formControlName="desc" limit="2048"></app-quill-custom>
              </mdb-form-control> 
        </div>
          <div class="mat-form-field-description mb-3 pt-1 pr-5">Briefly describe your organization.</div>
        </div>
    </div>

    <div class="row field-container">
        <div class="col-12">
            <mdb-form-control class="form-fill" >
                <app-mdbp-input mdbInput formControlName="phone" autocomplete="tel" type='tel' [showMaxLength]="false" maxLength="128" phoneInputMask="on" label='Phone Number'></app-mdbp-input>
                <span class="form-fill-error"  *ngIf="form.controls.phone.touched && form.controls.phone.invalid">Please provide Phone Number</span>
            </mdb-form-control>
        </div>
    </div>

    <div class="row field-container">
        <div class="col-12">
            <mdb-form-control class="form-fill" >
                <app-mdbp-input mdbInput formControlName="supportEmail" class="mdb-input" autocomplete="email" [showMaxLength]="false" type='email' maxLength="128" label='Support Email (optional)'></app-mdbp-input>
            </mdb-form-control>
        </div>
    </div>

    <div class="row justify-content-end mb-3">
        <div class="col-12 col-sm-4 col-lg-2">
            <button class="action-button btn btn--paybee btn--purple w-100" (click)="onNext()"> Next </button>
        </div>
    </div>

</div>
